export const UPLOAD = 'upload';
export const EMBED = 'embed';
